import { useState } from "react";
import styled from "styled-components";

import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import useApi from "../../hooks/useApi";

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const formatBRL = (v) => BRL.format(Number(v) || 0);

const formatDataBR = (iso) => {
    if (!iso) return "—";
    const str = String(iso).slice(0, 10);
    const [y, m, d] = str.split("-");
    if (!y || !m || !d) return str;
    return `${d}/${m}/${y}`;
};

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
    text-align: center;
`
const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
`
const Resumo = styled.div`
    margin: 15px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 13px;
    color: #111;
    p {
        margin: 0;
    }
    b {
        color: #242d34;
    }
`
const ErrorMsg = styled.p`
    margin: 15px 0 0 0;
    font-size: 13px;
    color: #b91c1c;
    text-align: center;
`
const BotoesWrapper = styled.div`
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${props => props.cancel ? '#e5e7eb' : '#e11d48'};
    color: ${props => props.cancel ? '#333' : 'white'};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: .2s all ease;
    &:disabled {
        background-color: ${props => props.cancel ? '#e5e7eb' : '#fda4af'};
        cursor: auto;
    }
    &:hover:not(:disabled) {
        background-color: ${props => props.cancel ? '#d1d5db' : '#be123c'};
    }
`

const ConfirmDeleteLancamento = ({ lancamento, fecharModal, onDelete }) => {

    const api = useApi();

    const [saving, setSaving] = useState(false);
    const [erro, setErro] = useState(null);

    const handleDelete = async () => {

        if (!lancamento?.id) return;

        setSaving(true);
        setErro(null);

        try {

            await api.post(`/Painel/API/FolhaPag/DeleteLancamento/index.php?id=${lancamento.id}`);

            if (onDelete) onDelete();
            fecharModal();

        } catch (error) {

            console.error("Erro ao excluir lançamento:", error);
            const msg = error?.response?.data?.message || "Erro ao excluir lançamento.";
            setErro(msg);

        } finally {

            setSaving(false);

        }

    }

    return (
        <Overlay state={true}>
            <Modal size="sm">
                <Titulo>Confirmar exclusão</Titulo>
                <Subtitulo>Tem certeza que deseja excluir este lançamento?</Subtitulo>
                {
                    lancamento && (
                        <Resumo>
                            <p><b>MOTIVO:</b> {lancamento.motivo}</p>
                            <p><b>COLABORADOR:</b> {lancamento.colaborador ?? "—"} ({lancamento.matricula})</p>
                            <p><b>VALOR:</b> {formatBRL(lancamento.valor)}</p>
                            <p><b>DATA:</b> {formatDataBR(lancamento.data)}</p>
                        </Resumo>
                    )
                }
                {erro && <ErrorMsg>{erro}</ErrorMsg>}
                <BotoesWrapper>
                    <Botao cancel type="button" onClick={fecharModal} disabled={saving}>CANCELAR</Botao>
                    <Botao type="button" onClick={handleDelete} disabled={saving}>
                        {saving ? "EXCLUINDO..." : "EXCLUIR"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    );

}

export default ConfirmDeleteLancamento;
